import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },

  emptyRoot: {
    marginTop: '0.5rem'
  },

  root: {
    display: 'grid',
    gridTemplateRows: 'auto',
    gridTemplateColumns: `1fr 1fr calc(${theme.size.base} * 2 + 0.5rem)`,
    gridGap: '0.5rem',
    margin: `0.5rem ${theme.size.base} 0 calc(${theme.size.sm} * 2)`
  },

  button: {
    minWidth: 'unset',
    width: 'fit-content',
    height: '32px'
  },

  clickable: {
    cursor: 'pointer'
  },

  padTop: {
    marginTop: '0.5rem'
  },

  padLeft: {
    marginLeft: `calc(${theme.size.sm} * 2)`
  },

  header: {
    fontSize: theme.size.sm
  }
}))

export default useStyles
